import assetPath from '/app/packages/lebenslauf/articles/src/assets/das-ultimative-handbuch-fuer-empfeh.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')